<div class="comment-header-area flex">
  <div class="comment-author-details flex">
    <nz-avatar [nzText]="getCommentAuthorNameInitials(createdBy)"
               [style]="{color:'#f56a00', backgroundColor:'#fde3cf'}"
               [nzSize]="35"></nz-avatar>
    <div class="comment-details">
      <div class="author-name-area">{{ createdBy }}</div>
      <div class="time-area"
           *ngIf="updatedDate">{{ formattedDate ?? setCommentCreatedDate(updatedDate) }}</div>
    </div>
  </div>

  <!-- Comment Actions Area -->
  <div class="comment-actions-area flex">

    <ng-container *ngIf="(activePerson?.id === createdById || activePerson?.id === assignedTo?.id)">
      <rappider-dropdown-menu rappiderClickStopPropagation
                              class="comment-actions-dropdown"
                              [icon]="commentActionsDropdownConfig.icon"
                              [items]="commentActionsDropdownConfig.items"
                              [placement]="commentActionsDropdownConfig.placement"
                              (menuItemClick)="onCommentMenuItemClick($event)"></rappider-dropdown-menu>
    </ng-container>
  </div>
</div>
<ng-container *ngIf="!isCommentEditModeActive">
  <rappider-tag *ngIf=" status === commentStatus.Completed"
                [text]="{text:'Completed',colorSettings: {color: '#fff'}}"
                [color]="'#52c41a'"></rappider-tag>
  <rappider-tag *ngIf="status !== commentStatus.Completed"
                [text]="{text:status,colorSettings: {color: 'var(--text-color)'}}"
                [color]="'var(--tag-color)'"></rappider-tag>
</ng-container>
